<template>
	<div class="full">
		<vxe-table :loading="loading" :data="data" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="staffid" title="分配对象">
				<template #default="{ row }">
					<span>{{$systemMethods.getstaff(row.targetstaffid)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="staffid" title="操作人">
				<template #default="{ row }">
					<span>{{$systemMethods.getstaff(row.staffid)}}</span>
				</template>
			</vxe-column>
			<vxe-column field="departmentid" title="操作时间">
				<template #default="{ row }">
					<span>{{$systemMethods.timestampToDate(row.commit_time)}}</span>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				data: [],
				loading: false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if (this.row) {
				this.getData()
			}
		},
		computed: {

		},

		methods: {
			getData() {
				this.loading = true
				this.$api.crmcustomer.listDetail(this.row.id,{type:'distribution'}).then((res) => {
					this.data = res
					this.loading = false
				}, () => {
					this.loading = false
				})
			}

		},
		components: {

		}
	}
</script>